import WorkspaceAPI from '../WorkspaceAPI';
import { WorkspaceInheritanceAPIResponse } from './WorkspaceInheritanceAPI.model';
import { toBase64 } from '../../../shared/util/base64';

const WorkspaceInheritanceAPI = WorkspaceAPI.injectEndpoints({
  endpoints(build) {
    return {
      /// {{BaseURL}}/api/billing/:encodedWorkspaceId/subworkspaces
      getChildren: build.query<WorkspaceInheritanceAPIResponse, string>({
        query: (workspaceId) => ({
          url: `/billing/${toBase64(workspaceId)}/subworkspaces`,
        }),
        providesTags: ['cancel-self', 'workspace-actions'],
      }),
    };
  },
});

export default WorkspaceInheritanceAPI;
